// extracted by mini-css-extract-plugin
export default {"tabMenu":"Mypage_tabMenu__tP9Ne","menuElemActive":"Mypage_menuElemActive__vH0+W","menuElem":"Mypage_menuElem__E4hCL","line":"Mypage_line__5DyxI"};